import { css } from '@/styled-system/css';

export const dotStyles = css.raw({
  width: '15px',
  height: '15px',
  borderRadius: '15px',
  backgroundColor:
    'purple.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
  float: 'left',
  marginTop: '3px',
  marginRight: '200',
});
